import React, { useState, useEffect, useCallback } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';
import { format } from 'date-fns';

import { t, number } from '~/helpers';
import api from '~/services/api';

import Filters from './components/Filters/index';
import ListData from './components/List/index';
import * as S from './styles';
import { tipoabastecimento, colorSet } from './utils/constants';

const delayRefresh = 2;

export default function DashboardContingencia() {
  const { token } = useSelector((state) => state.auth);

  const [params, setParams] = useState({
    // token,
    datahorainicialmovimentacao: format(new Date(), 'yyyy-MM-dd 00:00:00'),
    datahorafinalmovimentacao: format(new Date(), 'yyyy-MM-dd 23:59:59'),
    contingenciamovimentacaoabastecimento: [],
    idposto: [],
    idproduto: [],
    tipoveiculo: [],
    idempresaveiculo: [],
    idagrupamento: '3',
  });
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const graph1 = {
    series: data.contingencias?.map((value) => value?.registros) ?? [],

    options: {
      colors: data.contingencias?.map(
        (value) => colorSet[value.contingenciamovimentacaoabastecimento]
      ),
      labels:
        data.contingencias?.map(
          (value) => value?.contingenciamovimentacaoabastecimentostr
        ) ?? [],
      tooltip: {
        enabled: true,
        x: {
          show: false,
        },
        y: {
          formatter: (value) => number(value, 0),
        },
      },
      responsive: [
        {
          breakpoint: 700,
          options: {
            chart: {
              width: 400,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
        {
          breakpoint: 500,
          options: {
            chart: {
              width: 250,
              height: 300,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  };

  const graph2 = {
    options: {
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#546E7A',
      ],
      chart: {
        type: 'bar',
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: data?.contingenciasevolucao?.meses ?? [],
      },
      markers: {
        size: 0,
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false,
      },
      legend: {
        show: true,
      },
      tooltip: {
        enabled: true,
        x: {
          show: false,
        },
        y: {
          formatter: (value) => number(value, 0),
        },
      },
      dataLabels: {
        style: {
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          colors: ['#000000'],
        },
        formatter(value, opts) {
          return `${number(value, 1)}% / ${number(
            opts?.config.series[opts?.seriesIndex].data[opts?.dataPointIndex],
            0
          )}`;
        },
      },
    },
    series:
      data?.contingenciasevolucao?.series.map((value) => ({
        name: t(
          tipoabastecimento.items.filter(
            (abs) => abs.value === value.contingencia
          )[0].label
        ),
        data: value.data,
      })) ?? [],
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `dashboardscontigenciasabasts/?${new URLSearchParams(
          params
        ).toString()}`
      );
      setData(response.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, delayRefresh * 1000 * 60);

    return () => clearInterval(intervalId);
  }, [params]);

  return (
    <S.Wrapper>
      <S.HeaderWrapper>
        <Filters params={params} setParams={setParams} />
      </S.HeaderWrapper>
      <S.GraphGrid>
        {loading ? (
          <CircularProgress
            style={{ alignSelf: 'center', justifySelf: 'center' }}
          />
        ) : (
          <>
            <Chart
              options={graph1.options}
              series={graph1.series}
              type="donut"
              height="90%"
            />
            <ListData data={data?.contingencias} />
          </>
        )}
      </S.GraphGrid>
      <S.GraphGrid>
        {loading ? (
          <CircularProgress
            style={{ alignSelf: 'center', justifySelf: 'center' }}
          />
        ) : (
          <Chart
            options={graph2.options}
            series={graph2.series}
            type="bar"
            height="100%"
          />
        )}
      </S.GraphGrid>
    </S.Wrapper>
  );
}
